<template>
    <div class="mainpage">
        <div class="d-flex justify-content-between mb-3">
            <div class="d-flex">
                <!-- <div class="gap">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="searchValue" placeholder="Search by link name" @keyup="linkSearch"/>
                    </span>
                </div> -->
            </div>
            <div class="d-flex justify-content-end">
                <Calendar ref="searchCalendar" @date-select="dateSearch" class="gap" v-model="date" showIcon  selectionMode="range" :manualInput="false" placeholder="Last 30 days" :maxDate="maxDate"/>
                <Button icon="pi pi-plus" label="Create New" @click="createLink"/>
            </div>
        </div>
        <div class="custom-table">
            <DataTable class="p-datatable" :value="getTableData" tableStyle="min-width: 50rem"
                paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]"
                paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                <template #empty>
                    <div class="empty-state"><img class="empty-state-image" src="@/assets/images/empty-state.svg"/></div>
                    <div class="empty-state">No data available</div>
                </template>
                <Column class="overflow-column" field="Name" header="Link Name" style="max-width: 10vw"></Column>
                <Column class="overflow-column" field="LongURL" header="Long URL" style="max-width: 29vw"></Column>
                <Column field="Domain" header="Short URL">
                    <template #body="slotProps">
                        {{ slotProps.data.ShortURL ? slotProps.data.ShortURL : slotProps.data.CustomBackHalf ? slotProps.data.Domain + '/' + slotProps.data.CustomBackHalf : slotProps.data.Domain + '/xxxxxx' }}
                    </template>
                </Column>
                <Column field="LastUpdated" header="Updated On"></Column>
                <Column field="ExpiresAt" header="Expires On"></Column>
                <!-- <Column field="clicks" header="Clicks"></Column> -->
                <Column field="LinkId" header="">
                    <template #body="slotProps">
                        <i class="pi pi-eye cursor-pointer" @click="openReports(slotProps.data.LinkID)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import moment from 'moment'
export default {
    name: 'Links',
    components: {
    },
    data () {
        return {
            maxDate: null,
            searchValue: '',
            date: []
        }
    },
    methods: {
        createLink () {
            this.$router.push('/link/create')
        },
        openReports (id) {
            this.$router.push('/link/report?id=' + id)
        },
        async linkSearch () {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(async () => {
                await this.getLinksList()
            }, 500)
        },
        async dateSearch () {
            if (this.date[1] != null) {
                this.$refs.searchCalendar.overlayVisible = false
                await this.getLinksList()
            }
        },
        async getLinksList () {
            this.startDay = ''
            this.endDay = ''
            if (!((this.date[0] == null) ^ (this.date[1] == null))) {
                if (this.date[0] && this.date[1]) {
                    this.startDay = moment(this.date[0])
                    this.endDay = moment(this.date[1]).endOf('day')
                }
            } else {
                this.date = []
            }
            const data = {
                from: this.startDay,
                to: this.endDay,
                search: this.searchValue
            }
            this.globalLoader = true
            await this.$store.dispatch('Links/Link/fetchLinks', data)
            this.globalLoader = false
        }
    },
    computed: {
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapModels('general', ['globalLoader']),
        ...mapGetters('Links/Link', ['getTableData'])
    },
    async mounted () {
        this.maxDate = new Date()
        await this.getLinksList()
    }
}
</script>

<style>
</style>
